var _desc, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Wifi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer2",
    d: "M32 46.8a6.1 6.1 0 0 0-4.5 2 1 1 0 0 0 0 1.4l3.7 3.8a1 1 0 0 0 1.4 0l3.7-3.8a1 1 0 0 0 0-1.4 6.1 6.1 0 0 0-4.3-2z",
    fill: "#ff0000",
    stroke: "#ff0000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M18.4 39.9l4 4.5a14.6 14.6 0 0 1 19.2 0l4-4.5a20.6 20.6 0 0 0-27.1 0z",
    fill: "#ff0000",
    stroke: "#ff0000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer2",
    d: "M10.2 30.4l4 4.5a27.2 27.2 0 0 1 35.8 0l4-4.5a33.2 33.2 0 0 0-43.7 0z",
    fill: "#ff0000",
    stroke: "#ff0000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M32 9.8A45.6 45.6 0 0 0 2 21l4 4.5a39.6 39.6 0 0 1 52.1 0L62 21A45.6 45.6 0 0 0 32 9.8z",
    fill: "#ff0000",
    stroke: "#ff0000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifia);
export default __webpack_public_path__ + "static/media/wifia.b1f095732a308ac54cacec27c009032b.svg";
export { ForwardRef as ReactComponent };